<template>
  <div id="removeclass">
    <app-modal
      :modal-id="modalId"
      modal-alignment="top"
      modal-size="small"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
        >
          <div class="form-group row align-items-center">
            <label for="inputs_name" class="col-sm-3 mb-0">
              {{ $t("amount") }}
            </label>
            <app-input
              id="name"
              class="col-sm-9"
              type="text"
              v-model="bid.amount"
              :required="true"
            />
            <!-- <app-input
                id="id"
                class="col-sm-9"
                type="hide"
                v-model="inputs.id"
              /> -->
            <!-- <app-input
              id="company_id"
              class="col-sm-9"
              type="hide"
              v-model="inputs.company_id"
            /> -->
          </div>
        </form>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click="closeModal"
        >
          {{ $t("close") }}
        </button>
        <button
          type="button"
          class="btn btn-primary mr-2"
          data-dismiss="modal"
          @click="sendBid"
        >
          {{ $t("submit") }}
        </button>
      </template>
    </app-modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../../app/Mixins/ModalMixin";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper";
import {
  CUSTOMER_ROLE,
  CUSTOMER_STORE,
  CUSTOMER_UPDATE,
  JOB_BID_SEND,
} from "../../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      preloader: false,
      bid: {},
      inputs: {
        user: {
          password: "Pa$$w0rd!",
          confirm_password: "Pa$$w0rd!",
        },
        company: {},
      },
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.preloader = true;
      if (this.modalTitle == "Edit") {
        this.preloader = true;
        axiosPost(CUSTOMER_UPDATE, this.inputs)
          .then((res) => {
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {
        axiosPost(CUSTOMER_STORE, this.inputs)
          .then((res) => {
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },
    setRole() {
      axiosGet(CUSTOMER_ROLE)
        .then((res) => {
          this.inputs.user.roles = { 0: res.data.id };
        })
        .catch((error) => {
          
        });
    },
    sendBid() {
      axiosPost(JOB_BID_SEND, this.bid)
        .then((res) => {
          this.$toastr.s(res.data);
        })
        .catch((error) => {
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
          $("#demo-add-edit-Modal").modal("hide");
          this.$hub.$emit("reload-" + this.tableId);
        });
      
    },
  },
  mounted() {
    let myLocation = location.href;
    let split = myLocation.split("/");
    
    let id = split[6].split("?")[0];
    this.bid.job_id = id;
    this.setRole();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
